<template>
  <div>
    <TopHeader code="know" />

    <section class="container-fluid uc-bg2">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link :to="{ name: 'Knowledge' }" class="item"
                >案例库</router-link
              >
              <router-link to="" class="item">案例详情</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg2">
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-17">
            <section class="uc-ResourcesInfo uc-mr10">
              <div class="left">
                <div class="img-box">
                  <el-image :src="model.cover">
                    <div slot="error" class="image-slot">
                      <img src="../../assets/images/default-zs.png" />
                    </div>
                  </el-image>
                </div>
                <div class="btm">
                  <!--<button
                    class="btns"
                    hover-class="none"
                    @click="shareDialogVisible = true"
                  >
                    <el-tooltip content="分享" placement="top">
                      <img
                        src="../../assets/images/icon81-1.png"
                        alt="分享"
                        class="uc-icon20"
                      />
                    </el-tooltip>
                  </button>-->
                  <button class="btns" hover-class="none" @click="btnStorage">
                    <img
                      v-if="!isStorage"
                      src="../../assets/images/icon-storage-2.png"
                      alt="点击收藏"
                      class="uc-icon24"
                      title="点击收藏"
                    />
                    <img
                      v-if="isStorage"
                      src="../../assets/images/icon-storage-1.png"
                      alt="取消收藏"
                      class="uc-icon24"
                      title="取消收藏"
                    />
                  </button>
                  <a
                    v-if="model.is_download"
                    class="btns"
                    :href="model.url"
                    target="_blank"
                    download
                  >
                    <el-tooltip content="下载" placement="top">
                      <img
                        src="../../assets/images/icon81-3.png"
                        alt="下载"
                        class="uc-icon20"
                      />
                    </el-tooltip>
                  </a>
                </div>
              </div>
              <div class="right">
                <h2>{{ model.name }}</h2>
                <div class="con2">
                  <div class="item">
                    <span class="txt">所属类别：</span>{{ model.catalog_name }}
                  </div>
                  <div class="item"><span class="txt">浏览：</span>0次</div>
                  <div class="item"><span class="txt">下载：</span>0次</div>
                </div>
                <div class="con" v-html="model.description"></div>
                <div class="star-box">
                  <span class="txt">综合评分</span>
                  <div class="star">
                    <el-rate
                      disabled
                      show-score
                      text-color="#ff9900"
                      :value="model.evaluation_score"
                      :score-template="(model.evaluation_score || '--') + '分'"
                    >
                    </el-rate>
                  </div>
                  <div class="star-box-operate">
                    <h3>我的评分</h3>
                    <div class="star">
                      <el-rate
                        :disabled="myEvaluationScore > 0"
                        show-score
                        v-model="myEvaluationScore"
                        @change="postKnowledgeEvaluation"
                        :score-template="
                          (model.my_evaluation_score || '--') + '分'
                        "
                      ></el-rate>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div class="col-24 col-sm-7">
            <section class="uc-ResourcesAuthor">
              <h2>关于作者</h2>
              <div class="box">
                <div class="author">
                  <div class="face-box">
                    <img
                      :src="model.create_user_avatar"
                      :alt="model.create_user_name"
                      onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                    />
                  </div>
                  <div class="name">{{ model.create_user_name }}</div>
                </div>
                <img src="../../assets/images/bg81.png" class="line" />
                <div class="right">
                  <p>上传资源数</p>
                  <div class="number">{{ model.upload_count }}</div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg2 uc-pb40">
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-17">
            <section class="uc-ResourcesDetail uc-mr10" ref="waterContent">
              <iframe
                :src="model.viewer_url"
                style="width:100%;height:860px;"
                allowfullscreen="true"
                frameborder="0"
              />
            </section>
          </div>

          <div class="col-24 col-sm-7">
            <section class="g-sideCourseList">
              <div class="title">相关资源</div>
              <div class="content-empty" v-if="list.length == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div class="list">
                <div class="item" v-for="(item, index) in list" :key="index">
                  <router-link
                    :to="{
                      name: 'KnowledgeDetails',
                      params: { id: item.id },
                    }"
                    class="img-box"
                  >
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-zs.png" />
                      </div>
                    </el-image>
                  </router-link>

                  <div class="con">
                    <el-tooltip placement="top" effect="light">
                      <div slot="content">
                        {{ item.name }}
                      </div>
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <!-- <div class="txt">张学军</div> -->
                    <div class="btm">
                      <span class="el-icon-time">
                        {{ item.create_time }}
                      </span>
                      <!-- <span class="el-icon-view" style="float: right;">
                          10
                        </span> -->
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <div>
      <el-dialog
        :visible.sync="shareDialogVisible"
        :close-on-click-modal="false"
        width="25%"
        center
      >
        <span><img src="../../assets/images/code.png"/></span>
        <span slot="footer" class="dialog-footer">
          <p>打开微信扫一扫</p>
          <p class="uc-pt10">点击右上角进行分享</p>
        </span>
      </el-dialog>

      <el-dialog
        title="选择收藏夹"
        :visible.sync="outerVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
      >
        <el-dialog
          width="40%"
          title="新建收藏夹"
          :visible.sync="innerVisible"
          :destroy-on-close="true"
          :close-on-click-modal="false"
          :class="handleCloseDialog"
          append-to-body
        >
          <el-form :model="form" ref="form" :rules="rules">
            <el-input v-model="form.id" type="hidden"></el-input>
            <el-form-item
              label="名称"
              prop="name"
              :label-width="formLabelWidth"
            >
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="描述" :label-width="formLabelWidth">
              <el-input
                type="textarea"
                v-model.trim="form.description"
                autocomplete="off"
                :rules="{
                  required: true,
                  message: '请输入收藏夹名称',
                  trigger: 'blur',
                }"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click.native="handleCloseFavorites">取 消</el-button>
            <el-button type="primary" @click.native="handleCreateFavoritesSure"
              >确 定</el-button
            >
          </div>
        </el-dialog>
        <el-table
          :data="favoritesGridData"
          height="300px"
          style="cursor:pointer;"
          highlight-current-row
          @current-change="handleCurrentChange"
        >
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <el-radio
                :label="scope.row.row"
                v-model="radio"
                @change.native="getTemplateRow(scope.$index, scope.row)"
              ></el-radio>
            </template>
          </el-table-column>
          <el-table-column
            property="name"
            label="收藏夹"
            width="400"
          ></el-table-column>
          <el-table-column
            property="create_time"
            label="修改时间"
          ></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="outerVisible = false">取 消</el-button>
          <el-button @click="innerVisible = true">新建收藏夹</el-button>
          <el-button type="primary" @click="handleSelectFavoritesSure"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';
import watermark from '@/utils/watermark.js';

export default {
  name: 'KnowledgeDetails',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      query: { id: this.$route.params.id },
      model: {},
      myEvaluationScore: 0,
      list: {},

      shareDialogVisible: false,

      // 收藏相关--begin
      isStorage: false,
      innerVisible: false,
      outerVisible: false,
      favoritesGridData: [],
      radio: '',
      templateSelection: {},
      form: {
        id: 0,
        name: '',
        description: '',
      },
      formLabelWidth: '60px',
      rules: {
        name: [
          { required: true, message: '请输入收藏夹名称', trigger: 'blur' },
        ],
      },
      // 收藏相关--end
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.$router.go(0);
    },
  },
  methods: {
    loadData() {
      this.getKnowledgeDetails();
      this.getRelatedKnowledges();
    },
    // 点击收藏按钮
    btnStorage() {
      // this.isStorage = !this.isStorage;
      // console.log(this.isStorage);
      if (!this.isStorage) {
        this.outerVisible = true;
        this.getFavoritesTree();
      } else {
        const submitData = {
          tenant_id: this.query.id,
          tenant_type: 'Knowledge',
          is_collected: !this.isStorage,
        };
        // 取消收藏
        this.cancelToFavorites(submitData);
      }
    },
    // 创建文件夹
    handleCreateFavoritesSure() {
      const submitData = {
        id: this.form.id,
        name: this.form.name,
        description: this.form.description,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.postFavorites(submitData);
        }
      });
    },
    // 关闭窗口：点击取消
    handleCloseFavorites() {
      this.innerVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
    // 关闭窗口：点击X
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    // 获取选中行：收藏夹
    getTemplateRow(index, row) {
      this.templateSelection = row;
    },
    // 点击行选中
    handleCurrentChange(row) {
      // 如果没有row,终止
      if (!row) {
        return;
      }
      // 把当前行label绑定的值和v-model绑定的值相同时,单选按钮就可以选中
      this.radio = row.row;
      this.templateSelection = row;
    },
    // 确定选择收藏夹
    handleSelectFavoritesSure() {
      if (this.templateSelection.id === undefined) {
        this.$message.warning('请选择一个收藏夹');
        return;
      }
      const submitData = {
        favorites_id: this.templateSelection.id,
        name: this.templateSelection.name,
        description: this.form.description,
        tenant_id: this.query.id,
        tenant_type: 'Knowledge',
        is_collected: !this.isStorage,
      };
      // console.log(submitData);
      this.addToFavorites(submitData);
    },
    async getKnowledgeDetails() {
      const response = await this.$api.knowledge.getKnowledgeDetails(
        this.query
      );
      this.model = response.data.data;
      // 我的评分
      this.myEvaluationScore = this.model.my_evaluation_score;
      // 收藏状态
      this.isStorage = this.model.is_collected;
    },
    // 获取相关资源
    async getRelatedKnowledges() {
      const response = await this.$api.knowledge.getRelatedKnowledges(
        this.query
      );
      this.list = response.data.data;
    },
    // 提交评价
    async postKnowledgeEvaluation() {
      // 提交评价数据
      const submitData = {
        knowledge_id: this.query.id,
        score: this.myEvaluationScore,
      };
      const response = await this.$api.knowledge.postKnowledgeEvaluation(
        submitData
      );
      if (response.data.code === 200) {
        this.$message.success('感谢您的评价');
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 获取我的收藏夹
    async getFavoritesTree() {
      const response = await this.$api.favorites.getFavoritesTree();
      this.favoritesGridData = response.data.data;
    },
    // 添加收藏
    async addToFavorites(toFavorites) {
      const response = await this.$api.favorites.addToFavorites(toFavorites);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.outerVisible = false;
        this.isStorage = !this.isStorage;
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 取消收藏
    async cancelToFavorites(myFavorites) {
      const response = await this.$api.favorites.cancelToFavorites(myFavorites);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.isStorage = !this.isStorage;
      }
    },
    // 添加收藏：提交到后台
    async postFavorites(myFavorites) {
      const response = await this.$api.favorites.postFavorites(myFavorites);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.innerVisible = false;
        // push到列表
        this.favoritesGridData.unshift({
          id: response.data.data,
          name: this.form.name,
          description: '',
          create_time: this.$moment(new Date()).format('YYYY-MM-DD HH:mm'),
          relation_count: 0,
          course_count: 0,
          knowledge_count: 0,
        });
        // 清空表单
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
  },
  mounted() {
    watermark.set(
      this.$store.getters.user.first_name +
        ' ' +
        this.$store.getters.user.username,
      this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      this.$refs.waterContent
    );
  },
};
</script>
